import { Router } from '@angular/router';
import { UserService } from '../services';
import { UserRole } from '@ml/core/types/enums';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/user.service";
var EmployeeGuard = /** @class */ (function () {
    function EmployeeGuard(router, userService) {
        this.router = router;
        this.userService = userService;
    }
    EmployeeGuard.prototype.canActivate = function (next, state) {
        var user = this.userService.user;
        if (user.role === UserRole.ADMIN || user.role === UserRole.EMPLOYEE) {
            return true;
        }
        this.router.navigate(['/']);
        return false;
    };
    EmployeeGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmployeeGuard_Factory() { return new EmployeeGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UserService)); }, token: EmployeeGuard, providedIn: "root" });
    return EmployeeGuard;
}());
export { EmployeeGuard };
